import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ClearIcon from "@mui/icons-material/Clear";
import "../../styles/Header.css";
import { Link } from "react-router-dom";

/** Dropdown panel: softer than #0f172a→#1f356f, but not flat */
const MENU_PANEL_GRADIENT = "linear-gradient(135deg, #0f172a 0%, #1a2f56 100%)";

export default function Header({ MenuData, Province }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = (e) => {
    setAnchorEl(null);
  };

  const handleMenuClick = (e) => {
    setAnchorEl(null);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    let changeLogo = document.getElementById("headerlogo");
    if (Province !== "ON") {
      changeLogo.setAttribute("src", "../exp-logos/CDNwhite.png");
    } else {
      changeLogo.setAttribute("src", "../exp-logos/ONwhite.png");
    }
  }, [Province]);

  return (
    <AppBar position="sticky" className=" w-screen">
      <Toolbar
        className="appBar "
        sx={{
          background: "linear-gradient(135deg, #0f172a 0%, #1f356f 100%)",
        }}
      >
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{ mr: 2, color: "#ffffff" }}
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          {anchorEl === null ? (
            <MenuIcon fontSize="large" />
          ) : (
            <ClearIcon fontSize="large" />
          )}
        </IconButton>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          sx={{ mt: 1.5 }}
          className="header-menu"
          PaperProps={{
            elevation: 3,
            sx: {
              background: MENU_PANEL_GRADIENT,
            },
          }}
          MenuListProps={{
            style: {
              minWidth: 260,
              background: MENU_PANEL_GRADIENT,
              color: "#ffffff",
            },
            "aria-labelledby": "basic-button",
          }}
        >
          {MenuData.map((menuItem) => {
            const isExternalLink = menuItem.url.startsWith("http");
            return (
              <MenuItem
                component={isExternalLink ? "a" : Link}
                to={isExternalLink ? undefined : menuItem.url}
                href={isExternalLink ? menuItem.url : undefined}
                target={isExternalLink ? "_blank" : undefined}
                rel={isExternalLink ? "noopener noreferrer" : undefined}
                onClick={handleMenuClick}
                key={Math.random()}
                sx={{
                  fontSize: "16px",
                  color: "#ffffff",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.14)",
                  },
                }}
              >
                {menuItem.text}
              </MenuItem>
            );
          })}
        </Menu>
        <div className="logo-box flex items-center">
          <div>
            <Link to="/">
              <img
                onClick={handleMenuClick}
                src="../exp-logos/CDNwhite.png"
                className="header-logo cursor-pointer"
                id="headerlogo"
                alt="logo"
                data-my-value=""
              />
            </Link>
          </div>

          <div className="header-text">{Province} TRANSACTION GUIDE</div>
        </div>
      </Toolbar>
    </AppBar>
  );
}
